import React from 'react';
import { Row, Col, Card, Statistic, Typography, Progress, Tag, Tooltip } from 'antd';
import {
  BuildOutlined,
  CheckCircleOutlined,
  TeamOutlined,
  ApartmentOutlined,
  ArrowUpOutlined,
  DollarOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { all_routes } from '../../../../router/all_routes';
import { KpiMetrics, RevenueMetrics } from '../../../../types/super-admin.types';
const { Text } = Typography;

interface StatCardsProps {
  stats: KpiMetrics;
  revenueMetrics: RevenueMetrics;
  }

const StatCards: React.FC<StatCardsProps> = ({ stats, revenueMetrics }) => {

  return (
    <Row gutter={[16, 16]} className="mb-4">
      <Col xs={24} sm={12} md={6}>
        <Card className="stat-card" bordered={false}>
          <Statistic
            title={<Text strong>Toplam Şirket</Text>}
            value={stats.totalCompanies}
            valueStyle={{ color: '#1890ff' }}
            prefix={<BuildOutlined className="stats-icon bg-primary-light text-primary" />}
            suffix={
              <Tooltip title="Toplam şirket ve aktif şirket sayısı">
                <div className='d-flex flex-column align-items-end'>
                  <Tag color="green" className='mb-1'>
                    {stats.companyStatusActiveCompanies} Aktif
                  </Tag>
                  <Tag color="blue">
                    {stats.averageUsersPerCompany.toFixed(1)} çalışan/şirket
                  </Tag>
                </div>
              </Tooltip>
            }
          />
          <div className="stat-footer">
            <Progress 
              percent={100} 
              showInfo={false} 
              strokeColor="#1890ff" 
              size="small" 
            />
            <div className="d-flex justify-content-between align-items-center mt-2">
              <Link to={all_routes.superAdminCompanies}>Tüm Şirketler</Link>
              <ArrowUpOutlined style={{ color: '#52c41a' }} />
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card className="stat-card" bordered={false}>
          <Statistic
            title={<Text strong>Aktif Şirketler</Text>}
            value={stats.companyStatusActiveCompanies}
            valueStyle={{ color: '#52c41a' }}
            prefix={<CheckCircleOutlined className="stats-icon bg-success-light text-success" />}
            suffix={
              <Tooltip title="Aktif şirket oranı">
                <Tag color="success">
                  {stats.activeCompanyPercentage}%
                </Tag>
              </Tooltip>
            }
          />
          <div className="stat-footer">
            <Progress 
              percent={stats.activeCompanyPercentage} 
              showInfo={false} 
              strokeColor="#52c41a"
              size="small"
            />
            <div className="d-flex justify-content-between align-items-center mt-2">
              <Text type="secondary">Aktif Durum</Text>
              <ArrowUpOutlined style={{ color: '#52c41a' }} />
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card className="stat-card" bordered={false}>
          <Statistic
            title={<Text strong>Toplam Çalışan</Text>}
            value={stats.totalUsers}
            valueStyle={{ color: '#722ed1' }}
            prefix={<TeamOutlined className="stats-icon bg-purple-light text-purple" />}
          />
          <div className="stat-footer">
            <Progress 
              percent={100} 
              showInfo={false} 
              strokeColor="#722ed1" 
              size="small" 
            />
            <div className="d-flex justify-content-between align-items-center mt-2">
              <Text type="secondary">Tüm Şirketlerde</Text>
              <Tooltip title="Tüm şirketlerdeki çalışan sayısı">
                <Tag color="purple">Toplam Personel</Tag>
              </Tooltip>
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card className="stat-card" bordered={false}>
          <Statistic
            title={<Text strong>Toplam Gelir</Text>}
            value={revenueMetrics.totalRevenue}
            valueStyle={{ color: '#faad14' }}
            prefix={<DollarOutlined className="stats-icon bg-warning-light text-warning" />}
            suffix={
              <Tooltip title="Bu ay: {revenueMetrics.thisMonthRevenue}">
                <Tag color="warning">Bu ay: {revenueMetrics.thisMonthRevenue} </Tag>
              </Tooltip>
            }
          />
          <div className="stat-footer">
            <Progress 
              percent={100} 
              showInfo={false} 
              strokeColor="#faad14" 
              size="small" 
            />
            {/* <div className="d-flex justify-content-between align-items-center mt-2">
              <Text type="secondary">Bu ay: {revenueMetrics.thisMonthRevenue}</Text>
              <ArrowUpOutlined style={{ color: '#faad14' }} /> */}
            {/* </div> */}
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default StatCards; 